export const marshallRUC = (ruc: string) => {
    //we need to rid of the leading zeroes
    if (ruc.startsWith('0')) {
        let finalVal = '';
        let noMoreLeadingZeroes = false;
        const arr = Array.from(ruc);
        for (let i = 0; i < arr.length; i++) {
            if (arr[i] !== '0') {
                noMoreLeadingZeroes = true;
            }
            if (noMoreLeadingZeroes) {
                finalVal = finalVal.concat(arr[i]);
            }
        }
        return finalVal;
    }
    return ruc;
};
